/**
 * Skip Counting Question Data
 * 
 * Contains questions for skip counting practice (counting by 2s, 5s, and 10s).
 * 
 * @module skipCountingData
 */

// Skip Counting Questions
export const skipCountingQuestions = [
  { question: 'Count by 2s: 2, 4, 6, __', options: ['8', '7'], correct: '8', emoji: '➕' },
  { question: 'Count by 5s: 5, 10, 15, __', options: ['20', '16'], correct: '20', emoji: '✋' },
  { question: 'Count by 10s: 10, 20, 30, __', options: ['40', '35'], correct: '40', emoji: '🔟' },
  { question: 'Count by 2s: 8, 10, 12, __', options: ['14', '13'], correct: '14', emoji: '➕' },
  { question: 'Count by 5s: 20, 25, 30, __', options: ['35', '32'], correct: '35', emoji: '✋' },
  { question: 'Count by 10s: 40, 50, 60, __', options: ['70', '65'], correct: '70', emoji: '🔟' },
  { question: 'Count by 2s: 14, 16, 18, __', options: ['20', '19'], correct: '20', emoji: '➕' },
  { question: 'Count by 5s: 35, 40, 45, __', options: ['50', '48'], correct: '50', emoji: '✋' },
  { question: 'Count by 10s: 70, 80, 90, __', options: ['100', '95'], correct: '100', emoji: '🔟' },
  { question: 'Count by 2s: 22, 24, 26, __', options: ['28', '27'], correct: '28', emoji: '➕' },
  { question: 'Count by 5s: 50, 55, 60, __', options: ['65', '62'], correct: '65', emoji: '✋' },
  { question: 'Count by 10s: 100, 110, 120, __', options: ['130', '125'], correct: '130', emoji: '🔟' },
  { question: 'Count by 2s: 30, 32, 34, __', options: ['36', '35'], correct: '36', emoji: '➕' },
  { question: 'Count by 5s: 65, 70, 75, __', options: ['80', '78'], correct: '80', emoji: '✋' },
  { question: 'Count by 10s: 130, 140, 150, __', options: ['160', '155'], correct: '160', emoji: '🔟' },
  { question: 'Count by 2s: 38, 40, 42, __', options: ['44', '43'], correct: '44', emoji: '➕' },
  { question: 'Count by 5s: 80, 85, 90, __', options: ['95', '92'], correct: '95', emoji: '✋' },
  { question: 'Count by 10s: 160, 170, 180, __', options: ['190', '185'], correct: '190', emoji: '🔟' }
];

